class Notification {
    'use strict';

    constructor(){
        this.checkInterval = null;

        if (Audio) {
            this.audio = new Audio('componentResources/global/notificationSound.mp3');
        }
    }

    playSound() {
        if(this.audio)
            this.audio.play();
    }

    clear(){
        if(this.checkInterval){
            clearInterval(this.checkInterval);
        }
    }

    getLast(){
        return new Promise((resolve, reject)=>{
            if(!window.AuthMiddleware.user || !window.AuthMiddleware.user.login_token) reject(false);
            window.axios.get('notification?filter=isRead|=|FALSE&sort=date|desc')
                .then((response) => {
                    let notifications = response.data;
                    notifications.map(element=>{
                        element.date = moment(element.date).fromNow();
                        return element;
                    });
                    resolve(notifications);
                })
                .catch(()=>{reject(false)});
        });
    }

    getAllRead(){
        return new Promise((resolve, reject)=>{
            axios.get('notification?filter=isRead|=|TRUE&sort=date|desc')
                .then((response) => {
                    let notifications = response.data;
                    notifications.map(element=>{
                        element.date = moment(element.date).fromNow();
                        return element;
                    });
                    resolve(notifications);
                })
                .catch(()=>{reject(false)});
        });
    }

    setAsRead(id){
        return new Promise((resolve, reject)=>{
            window.axios.put(`notification/${id}/read`)
                .then((response) => {
                    resolve(true);
                })
                .catch(()=>{reject(false)});
        });
    }

}

export default Notification;


